export const detectFileType = (url) => {
  if (!url) return "unknown";

  if (url.startsWith("data:")) {
    if (url.includes("application/pdf")) return "pdf";
    if (url.includes("image/")) return "image";
    return "unsupported";
  }

  const urlWithoutQueryParams = url.split("?")[0];
  const extension = urlWithoutQueryParams.split(".").pop().toLowerCase();

  if (["png", "jpg", "jpeg", "gif", "svg"].includes(extension)) return "image";
  if (extension === "pdf") 
     return "pdf";
  return "unsupported";
};
